import { type LocationFacility, type UnitFacility } from '@/api/accommodation/types'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import EquipmentCardItem from './EquipmentCardItem'

function EquipmentCard({ facility, locationFacility }: { facility: UnitFacility; locationFacility: LocationFacility }) {
  return (
    <Accordion type="single" collapsible className="space-y-4" defaultValue="general">
      <AccordionItem value="general">
        <AccordionTrigger>Obecné vybavení</AccordionTrigger>
        <AccordionContent>
          <ul>
            <li className="grid grid-cols-2 gap-2 text-sm">
              <EquipmentCardItem text="Klimatizace" equipped={facility.general.airConditioning} />
              <EquipmentCardItem text="Krb" equipped={facility.general.indoorFireplace} />
              <EquipmentCardItem text="Kamna na dřevo" equipped={facility.general.woodHeating} />
              <EquipmentCardItem text="Pračka" equipped={facility.general.washingMachine} />
              <EquipmentCardItem text="Internet" equipped={facility.general.internet} />
              <EquipmentCardItem text="TV" equipped={facility.general.tv} />
            </li>
          </ul>
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="bathroom">
        <AccordionTrigger>Koupelna</AccordionTrigger>
        <AccordionContent>
          <ul>
            <li className="grid grid-cols-2 gap-2 text-sm">
              <EquipmentCardItem text="Vana" equipped={facility.bathroom.bathtub} />
              <EquipmentCardItem text="Sprchový kout " equipped={facility.bathroom.shower} />
              <EquipmentCardItem text="Ručníky pro hosty" equipped={facility.bathroom.towels} />
              <EquipmentCardItem text="Mýdla a šampóny" equipped={facility.bathroom.toiletries} />
              <EquipmentCardItem text="Fén" equipped={facility.bathroom.hairdryer} />
            </li>
          </ul>
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="bedroom">
        <AccordionTrigger>Ložnice</AccordionTrigger>
        <AccordionContent>
          <ul>
            <li className="grid grid-cols-2 gap-2 text-sm">
              <EquipmentCardItem text="Manželská postel" equipped={facility.bedroom.doubleBed} />
              <EquipmentCardItem text="Oddělené postele" equipped={facility.bedroom.twinBeds} />
              <EquipmentCardItem text="Dětská postýlka" equipped={facility.bedroom.childCrib} />
            </li>
          </ul>
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="kitchen">
        <AccordionTrigger>Kuchyně</AccordionTrigger>
        <AccordionContent>
          <ul>
            <li className="grid grid-cols-2 gap-2 text-sm">
              <EquipmentCardItem text="Myčka" equipped={facility.kitchen.dishwasher} />
              <EquipmentCardItem text="Sporák" equipped={facility.kitchen.stove} />
              <EquipmentCardItem text="Lednice" equipped={facility.kitchen.refrigerator} />
              <EquipmentCardItem text="Trouba" equipped={facility.kitchen.oven} />
              <EquipmentCardItem text="Mikrovlná trouba" equipped={facility.kitchen.microwave} />
              <EquipmentCardItem text="Nádobí" equipped={facility.kitchen.dishes} />
              <EquipmentCardItem text="Základní ingredience" equipped={facility.kitchen.basicCookingIngredients} />
              <EquipmentCardItem text="Dětská židlička" equipped={facility.kitchen.highChair} />
              <EquipmentCardItem text="Kávovar" equipped={facility.kitchen.automaticCoffeeMachine} />
              <EquipmentCardItem text="Nespresso kávovar" equipped={facility.kitchen.nespressoCoffeeMachine} />
              <EquipmentCardItem text="Vybavení na filtrovanou kávu" equipped={facility.kitchen.filterCoffeeMaker} />
            </li>
          </ul>
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="other">
        <AccordionTrigger>Další vybavení</AccordionTrigger>
        <AccordionContent>
          <ul>
            <li className="grid grid-cols-2 gap-2 text-sm">
              <EquipmentCardItem text="Zahrada" equipped={locationFacility.garden} />
              <EquipmentCardItem text="Terasa" equipped={locationFacility.terrace} />
              <EquipmentCardItem text="Bazén" equipped={locationFacility.pool} />
              <EquipmentCardItem text="Vířivka" equipped={locationFacility.whirlpool} />
              <EquipmentCardItem text="Koupací sud" equipped={locationFacility.hotTub} />
              <EquipmentCardItem text="Sauna" equipped={locationFacility.sauna} />
              <EquipmentCardItem text="Fitness" equipped={locationFacility.fitness} />
              <EquipmentCardItem text="Ohniště" equipped={locationFacility.outdoorFireplace} />
              <EquipmentCardItem text="Gril" equipped={locationFacility.grill} />
              <EquipmentCardItem text="Parkování zdarma" equipped={locationFacility.freeParking} />
              <EquipmentCardItem text="Restaurace" equipped={locationFacility.restaurant} />
              <EquipmentCardItem text="Snídaně v ceně" equipped={locationFacility.breakfastIncluded} />
              <EquipmentCardItem text="Bar" equipped={locationFacility.bar} />
              <EquipmentCardItem text="Sportoviště" equipped={locationFacility.sportFacility} />
              <EquipmentCardItem text="Dětské hřiště" equipped={locationFacility.childrenPlayground} />
            </li>
          </ul>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}

export default EquipmentCard
